import React from 'react';
import DecisionTree from './components/decision-tree/decision-tree'
import './App.css';

function App() {
  return (

    <DecisionTree />

  );
}

export default App;
